/**
 * sl-jsx3.16.3: Groups Tab — Workspace Settings entry point.
 *
 * Only available on cloud workspaces.
 */
import { AffineErrorBoundary } from '@affine/core/components/affine/affine-error-boundary';
import { WorkspaceService } from '@affine/core/modules/workspace';
import { useService } from '@toeverything/infra';
import type { ReactElement } from 'react';

import { CloudGroupsPanel } from './groups-panel';

export const GroupsPanel = (): ReactElement | null => {
  const workspace = useService(WorkspaceService).workspace;

  if (workspace.flavour === 'local') {
    return null;
  }

  return (
    <AffineErrorBoundary>
      <CloudGroupsPanel />
    </AffineErrorBoundary>
  );
};
